import { TestimonialCarouselProps } from '../components/testimonials-carousel';

export const homepageTestimonials: TestimonialCarouselProps['testimonials'] = [
  {
    imagePath: '/images/experiments/ab_plp_redesign_2025/tobias-frei.png',
    labelKey: 'testimonials.tobiasFrei.label',
    quoteKey: 'testimonials.tobiasFrei.quote',
    name: 'Tobias Frei',
    title: 'Digital Engineer',
    quoteColor: 'light',
    labelColor: 'dark',
  },
  {
    imagePath: '/images/experiments/ab_plp_redesign_2025/satyajit-ovelil.png',
    labelKey: 'testimonials.satyajitOvelil.label',
    quoteKey: 'testimonials.satyajitOvelil.quote',
    name: 'Satyajit Ovelil',
    title: 'Senior Analyst - Data & AI',
    quoteColor: 'light',
    labelColor: 'dark',
  },
  {
    imagePath: '/images/experiments/ab_plp_redesign_2025/janay-harris.png',
    labelKey: 'testimonials.janayHarris.label',
    quoteKey: 'testimonials.janayHarris.quote',
    name: 'Janay Harris',
    title: 'Tech Student',
    quoteColor: 'dark',
    labelColor: 'dark',
  },
  {
    imagePath: '/images/experiments/ab_plp_redesign_2025/nguyen-tuan-minh.png',
    labelKey: 'testimonials.nguyenTuanMinh.label',
    quoteKey: 'testimonials.nguyenTuanMinh.quote',
    name: 'Nguyễn Tuấn Minh',
    title: 'CHRO at FPT Software',
    quoteColor: 'light',
    labelColor: 'light',
  },
  {
    imagePath: '/images/experiments/ab_plp_redesign_2025/keith-myer.png',
    labelKey: 'testimonials.keithMyer.label',
    quoteKey: 'testimonials.keithMyer.quote',
    name: 'Keith Myer',
    title: 'Mobile Developer at Meta',
    quoteColor: 'dark',
    labelColor: 'light',
  },
  {
    imagePath: '/images/experiments/ab_plp_redesign_2025/eliza-fury.png',
    labelKey: 'testimonials.elizaFury.label',
    quoteKey: 'testimonials.elizaFury.quote',
    name: 'Eliza Fury',
    title: 'Software Engineer',
    quoteColor: 'light',
    labelColor: 'dark',
  },
  {
    imagePath: '/images/experiments/ab_plp_redesign_2025/federico-martini.png',
    labelKey: 'testimonials.federicoMartini.label',
    quoteKey: 'testimonials.federicoMartini.quote',
    name: 'Federico Martini',
    title: 'AI Engineering Manager & Tech Leader',
    quoteColor: 'light',
    labelColor: 'dark',
  },
];
